<template>
  <div>
    <FareServicesList
      :services-list="services.slice(0, VISIBLE_DESCRIPTION_AMOUNT)"
    />
    <FareServicesExpandable
      v-if="services.length > VISIBLE_DESCRIPTION_AMOUNT"
      :fare-idx="fareIdx"
      :services-list="services.slice(VISIBLE_DESCRIPTION_AMOUNT)"
      class="mt-2"
    />
  </div>
</template>

<script setup lang="ts">
  import type { Airflow } from '@aviata/platform-types';

  import FareServicesList from './FareServicesList.vue';
  import FareServicesExpandable from './FareServicesExpandable.vue';

  defineProps<{
    services: Airflow.FareFamily.Description.Entity[];
    fareIdx: number;
  }>();

  const VISIBLE_DESCRIPTION_AMOUNT = 4;
</script>
